// ===================
// Theme
// ===================

const theme = {}

// container
theme.container = {
  background: "#F6F6F6",
  gutter: {
    horizontal: 0,
    vertical: 10,
  },
  zIndex: 2001,
}

// header
theme.header = {
  height: 40,
}
theme.close = {
  fill: "#80583F",
}

// footer
theme.footer = {
  color: "#fff",
  count: {
    color: "rgba(255, 255, 255, .75)",
    fontSize: ".85em",
  },
  height: 40,
  gutter: {
    horizontal: 0,
    vertical: 5,
  },
}

// thumbnails
theme.thumbnail = {
  activeBorderColor: "#fff",
  size: 50,
  gutter: 2,
}

// arrow
theme.arrow = {
  background: "rgba(0,0,0,.2)",
  fill: "#80583F",
  height: 50,
}

export default theme
